import React, { useState } from 'react';

interface Props extends React.ImgHTMLAttributes<HTMLImageElement> {
  fallback: string;
}

const UploadedImage: React.FC<Props> = ({ fallback, src, ...rest }) => {
  const [imgSrc, setImgSrc] = useState<string | undefined>(src);
  const [hasError, setHasError] = useState(false);

  const handleError = () => {
    if (!hasError) {
      setImgSrc(fallback);
      setHasError(true);
    }
  };

  return (
    <img
      {...rest}
      src={imgSrc || fallback}
      onError={handleError}
      style={{ display: 'block', maxWidth: '100%', ...rest.style }}
    />
  );
};

export default UploadedImage;